export interface ValidationResult {
  isValid: boolean;
  errorMessage: string;
}

export const SuccessValidationResult: ValidationResult = {
  isValid: true,
  errorMessage: ""
};

export const EmptyErrorValidationResult: ValidationResult = {
  isValid: false,
  errorMessage: ""
};